import React, { useState } from "react";
import { CustomColorPicker } from "./CustomColorPicker";
import TitleIcon from '@mui/icons-material/Title';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import EditIcon from '@mui/icons-material/Edit';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import VisibilityIcon from '@mui/icons-material/Visibility';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import Slider from '@mui/material/Slider';

interface Props {
  setActiveOverlay?: (overlay: string) => void;
}

const ColorSettingsSidebar: React.FC<Props> = ({ setActiveOverlay }) => {
  const [color, setColor] = useState("#2ECC71");

  return (
    <>
      <div className="editor_card">
        <h3>Overlays</h3>
        <div className="overlay_tabs">
          <figure className="tab_btn" onClick={() => setActiveOverlay?.('text')}>
            <img src="/static/images/text_icon.svg" alt="text_icon" />
            <figcaption>Text</figcaption>
          </figure>
          <figure className="tab_btn active">
            <ColorLensIcon sx={{ fontSize: 20 }} />
            <figcaption>Color</figcaption>
          </figure>
          <figure className="tab_btn" onClick={() => setActiveOverlay?.('upload')}>
            <img src="/static/images/upload.svg" alt="color_upload_icon" />
            <figcaption>Upload</figcaption>
          </figure>
        </div>
      </div>

      <div className="editor_card color_customization">
        <h3>Color Customization</h3>
        <div className="region_selector">
          <div className="region_info">
            <div className="color_dot"></div>
            <div className="text_info">
              <span>Active Region</span>
              <strong>Region 1</strong>
            </div>
          </div>
          <EditIcon className="edit_icon" />
        </div>

        <CustomColorPicker color={color} onChange={setColor} />

        <div className="hex_input">
          <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
            <div className="color_preview" style={{ background: color }}></div>
            <span>HEX</span>
          </div>
          <span className="value">{color.toUpperCase()}</span>
          <ContentCopyIcon
            className="copy_icon"
            style={{ cursor: 'pointer' }}
            onClick={() => navigator.clipboard.writeText(color.toUpperCase())}
          />
        </div>
      </div>

      <div className="editor_card">
        <h3>Layers</h3>
        <div className="layers_list">
          <div className="layer_item">
            <div className="layer_left">
              <span className="micro_img">
                <img src="/static/images/dice.svg" alt="dice" />

              </span>
              <img src="/static/images/avtar.svg" alt="" className="thumb" />
              <div className="info">
                <strong>Family Photo</strong>
                <span>Image</span>
              </div>
            </div>
            <div className="layer_right">
              <img src="/static/images/trash.svg" alt="" className="thumb" />
              <VisibilityIcon sx={{ fontSize: 18, color: '#fff', opacity: 0.5 }} />


            </div>
          </div>

          <div className="layer_item">
            <div className="layer_left">
              <span className="micro_img">
                <img src="/static/images/dice.svg" alt="dice" />
              </span>
              <img src="/static/images/leaf.svg" alt="leaf" className="thumb" style={{ background: '#222' }} />
              <div className="info">
                <strong>Logo</strong>
                <span>Image</span>
              </div>
            </div>
            <div className="layer_right">
              <img src="/static/images/trash.svg" alt="" className="thumb" />
              <VisibilityIcon sx={{ fontSize: 18, color: '#fff', opacity: 0.5 }} />
            </div>
          </div>
        </div>
      </div>

      <div className="editor_card layer_settings">
        <h3>Layer Setting</h3>
        <div className="setting_row">
          <div className="header">
            <span>Opacity</span>
            <span className="value">100%</span>
          </div>
          <Slider className="progress_bar" defaultValue={100} min={0} max={100} />
        </div>

        <div className="setting_row">
          <div className="header">
            <span>Blend Mode</span>
          </div>
          <div className="dropdown">
            <span>Normal</span>
            <KeyboardArrowDownIcon className="arrow" />
          </div>
        </div>
      </div>
    </>
  );
};

export default ColorSettingsSidebar;
